export type GuideTarget = {
  kind: 'guide_section'
  sectionId: string
  anchor: string
  path: string
}
export type GuideSource = {
  account: string
  recommendationId: string
  sectionId: string
}
export const guideAnchorPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
export const guidePath = (anchor: string) => `/guide#${anchor}`
